import { apiClient } from "../config";

async function deleteProgram(id: any) {
  const res = await apiClient.delete(`/admin/programs/${id}`);
  return res.data;
}

export default deleteProgram;
